import React from 'react'

export default function Footer() {
    return (
        <footer className="main-footer">
            <strong>Copyright © 2024 <a href="https://www.mymedicalsecretary.com.au/">MyMedicalSecretary</a>. </strong>
            All rights reserved.
            <div className="float-right d-none d-sm-inline-block">
                <b>Version</b> 3.0
            </div>
        </footer>

    )
}
